import { lazy } from "react";

// Protected routes
export const LazyDashboard = lazy(() => import("@/routes/dashboard/dashboard").then(m => ({ default: m.Dashboard })));

export const LazyPatientList = lazy(() =>
  import("@/routes/patients/patient-list").then(m => ({ default: m.PatientList }))
);

export const LazyPatientHistory = lazy(() =>
  import("@/routes/patients/patient-history/patient-history").then(m => ({ default: m.default }))
);

export const LazyPractitioner = lazy(() =>
  import("@/routes/practitioner/practitioner").then(m => ({ default: m.Practitioner }))
);

export const LazyProfile = lazy(() => import("@/routes/profile/profile").then(m => ({ default: m.Profile })));

export const LazyAboutPage = lazy(() => import("@/routes/profile/about").then(m => ({ default: m.AboutPage })));

export const LazyOrganizationSettings = lazy(() =>
  import("@/routes/organization-settings/organization-settings").then(m => ({ default: m.OrganizationSettings }))
);

export const LazyAnalytics = lazy(() => import("@/routes/analytics/analytics").then(m => ({ default: m.Analytics })));

// Auth pages
export const LazyLogin = lazy(() => import("@/pages/login/login").then(m => ({ default: m.Login })));

export const LazyRegister = lazy(() => import("@/pages/register/index").then(m => ({ default: m.Register })));

export const LazyForgotPassword = lazy(() =>
  import("@/pages/forgot-password/forgot-password").then(m => ({ default: m.ForgotPassword }))
);

export const LazySubmitResetPassword = lazy(() =>
  import("@/pages/submit-reset-password/submit-reset-password").then(m => ({ default: m.SubmitResetPassword }))
);

export const LazySetupNewPassword = lazy(() =>
  import("@/pages/setup-new-password/setup-new-password").then(m => ({ default: m.SetupNewPassword }))
);

export const LazySetupMfaPage = lazy(() => import("@/pages/mfa/setup-mfa").then(m => ({ default: m.SetupMfaPage })));

export const LazyVerifyMfaPage = lazy(() => import("@/pages/mfa/verify-mfa").then(m => ({ default: m.VerifyMfaPage })));
